import script from "./AppSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSideBar.vue?vue&type=script&setup=true&lang=js"

import "./AppSideBar.vue?vue&type=style&index=0&id=43d0d568&lang=scss&scoped=true"

import exportComponent from "/builds/partout-chez-nous/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43d0d568"]])

export default __exports__